var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Icon } from '@a-type/ui';
import { useLocalStorage } from '../hooks/useStorage.js';
export function ReloadButton(_a) {
    var { onClick } = _a, props = __rest(_a, ["onClick"]);
    const [_, setLastErrorReload] = useLastErrorReload();
    const refresh = () => {
        setLastErrorReload(Date.now() + 500);
        window.location.reload();
    };
    return (_jsxs(Button, Object.assign({}, props, { onClick: (ev) => {
            onClick === null || onClick === void 0 ? void 0 : onClick(ev);
            refresh();
        }, children: [_jsx(Icon, { name: "refresh" }), _jsx("span", { children: "Refresh" })] })));
}
function useLastErrorReload() {
    return useLocalStorage('lastErrorReload', 0);
}
const now = Date.now();
export function useHadRecentError() {
    const [lastErrorReload] = useLocalStorage('lastErrorReload', 0);
    const hadRecentError = lastErrorReload < now && lastErrorReload > now - 1000 * 60 * 60;
    return hadRecentError;
}
//# sourceMappingURL=ReloadButton.js.map